import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { Leaf } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export default function AuthCallback() {
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = location.hash.split("session_id=")[1]?.split("&")[0];
    api.post("/auth/google/session", { session_id: sessionId })
      .then(() => window.location.replace(window.location.origin + "/admin"))
      .catch((e) => {
        toast.error(e?.response?.data?.detail || "Accesso Google non riuscito");
        window.location.replace(window.location.origin + "/admin");
      });
  }, [location]);

  return (
    <main className="flex min-h-screen flex-col items-center justify-center gap-4 bg-forest text-bone" data-testid="auth-callback">
      <Leaf className="h-8 w-8 animate-pulse text-terra" strokeWidth={1.5} />
      <p className="font-accent text-xs uppercase tracking-[0.25em]">Accesso in corso…</p>
    </main>
  );
}
